import { type GetServerSideProps } from 'next';

import { getProfilePropsData } from '../../../../modules/profile/shared';

import { ExternalProfileTemplate } from '../../../../templates';
import { externalPageProps } from '../../../../modules/profile/external/externalPageProps';

import { withEnhancedPageHandler } from '../../../../middlewares/withEnhancedPageHandler';
import { staticContent } from '../../../../data/seja-um-profissional';

const ProfilePage = (props) => <ExternalProfileTemplate {...props} />;

const getServerSidePropsHandler: GetServerSideProps = async ({
  params,
  query,
}) => {
  const { root, slug } = params;
  const profileSlug = slug.slice(-1);
  const shouldRefresh = query.refresh === 'true' || false;

  const profilePageProps = await getProfilePropsData({
    profileSlugId: profileSlug as string,
    limitReviews: 3,
    page: 1,
    refresh: shouldRefresh,
    pagePropsFn: externalPageProps,
  });

  if (!profilePageProps) {
    return {
      redirect: {
        destination: `/${root}`,
        permanent: false,
      },
    };
  }

  return {
    props: {
      staticContent,
      profilePageProps,
    },
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default ProfilePage;
